import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Button from '../Button';
import SecondaryButton from '../SecondaryButton';
import Spinner from '../Spinner';

import { useMediaQuery } from 'react-responsive';
import { Images } from '../../themes';
import { Container, Content, Label, Image, Span } from './styles';

export default function TermsFooter({ fetching, onAccept, onDecline }) {
  const [accepted, acceptTerms] = useState(false);
  const toggleTerms = () => acceptTerms(!accepted);
  const isMobile = useMediaQuery({ query: '(max-width: 960px)' });

  return (
    <Container>
      <SecondaryButton text="Decline" onClick={onDecline} />
      <Content>
        <Label>
          <Image
            src={
              accepted ? `${Images.icons.checked}` : `${Images.icons.unchecked}`
            }
            onClick={toggleTerms}
          />
          <Span onClick={toggleTerms}>
            {isMobile ? 'I agree' : 'I have read and agree to the terms'}
          </Span>
        </Label>
        {fetching ? (
          <Spinner
            size={
              isMobile ? { width: 124, height: 43 } : { width: 210, height: 47 }
            }
          />
        ) : (
          <Button
            disabled={!accepted}
            onClick={onAccept}
            icon={Images.icons.instation}
            alt="InStation icon"
            text="Accept terms"
          />
        )}
      </Content>
    </Container>
  );
}

TermsFooter.propTypes = {
  fetching: PropTypes.bool,
  onAccept: PropTypes.func.isRequired,
  onDecline: PropTypes.func.isRequired,
};
